import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { lazy, Suspense } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyLeftMenuDrawerContent = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "main-menu-left-drawer-content" */"./LeftMenuDrawerContent");
});
var LeftMenuDrawerContent = function LeftMenuDrawerContent(props) {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(LazyLeftMenuDrawerContent, _objectSpread({}, props))
  });
};
export default LeftMenuDrawerContent;